export default String.raw`
{% assign popupType = include -%}

{% capture count -%}
    <span class="after-adding-to-{{popupType}}-count-js"></span>
{% endcapture -%}

<!-- Cart Name -->
{% if popupType == 'cart' -%}
    {% for cart in customer.Carts -%}
        {% if cart.Current == true -%}
            {% assign cartName = cart.Name -%}
            {% assign cartId = cart.Id -%}
            {% break -%}
        {% endif -%}
    {% endfor -%}

    {% capture cartNameUpdatable -%}
        <span class="small-cart-name-to-replace-js">{{cartName}}</span>
    {% endcapture -%}
{% endif -%}

<dialog tabindex="-1" class="dialog after-adding-to-popup after-adding-to-{{popupType}}-popup after-adding-to-{{popupType}}-popup-js">
	<div class="dialog__header">
        <svg height="24" width="24" fill="#008945">
            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
        </svg>
		<h3 class="dialog__header-title">
            {% if popupType == 'cart' -%}
                {{translations.ProductsAddedToCart | Format: count, cartNameUpdatable}}
            {% elseif popupType == 'inquiry' -%}
                {{translations.ProductsAddedToInquiry | Format: count }}
            {% elseif popupType == 'wishlist' -%}
                {{translations.AddedToWishList | Format: count }}
            {% endif -%}
        </h3>
		<form method="dialog">
			<button class="dialog__close close-js" aria-label="{{ translations.Close }}">
				<svg aria-hidden="true" height="24" width="24">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
				</svg>
			</button>
		</form>
	</div>
	<div class="dialog__content">
        {% comment -%} Succesfully added products {% endcomment -%}
        <ul tabindex="-1" class="products__list products-js"></ul>

        {% if popupType == 'cart' and config.Products.AIEnabled == true -%}
            {% comment -%} AI Recommendations - only after adding to cart {% endcomment -%}
            <div class="ai-recommended ai-recommended-js"></div>
        {% endif -%}
	</div>
    <div class="dialog__actions">
        <form method="dialog">
            <button class="pure-button close-js" style="gap: 10px;">
                <svg height="14" width="9">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-left-{{settings.iconStyle}}"></use>
                </svg>
                <span>{{translations.BackToShopping}}</span>
            </button>
        </form>
        {% if popupType == 'cart' -%}
            <a class="primary-action-button" href="{{ page.BaseHref }}{{ config.DefinedPages.Order.Url }}">
                <span>{{translations.GoToCart}}</span>
                <svg height="24" width="24">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{settings.iconStyle}}"></use>
                </svg>
            </a>
        {% elseif popupType == 'inquiry' -%}
            <button class="primary-action-button load-inquiry-js" data-url="{{ page.BaseHref }}{{ config.DefinedPages.Order.Url }}?add-inquiry=true" data-inquiry-id="">
                <span>{{translations.GoToInquiry}}</span>
                <svg height="24" width="24">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#file-invoice-dollar-{{settings.iconStyle}}"></use>
                </svg>
            </button>
        {% elseif popupType == 'wishlist' -%}
            <a class="primary-action-button" href="{{ page.BaseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=wishlist-details">
                <span>{{translations.GoToWishList}}</span>
                <svg height="24" width="24">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{settings.iconStyle}}"></use>
                </svg>
            </a>
        {% endif -%}
    </div>
</dialog>
`